import React from 'react';
import {GenderList} from "components/gender/GenderList";
import {Provider} from "components/gender/GenderContext";

export const Genders = () => {

    return (
        <Provider>
            <GenderList/>
        </Provider>
    );
}
